import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import { LanguageProvider, useLanguage } from 'contexts/LanguageContext'; // Also import useLanguage here
import ScrollButton from 'ui-component/ScrollToTopButton';
import GlobalSearch from 'ui-component/global-search/GlobalSearch';
import { useHotkeys } from 'react-hotkeys-hook';
import toast, { Toaster } from 'react-hot-toast';
import { setDisplayTheme, setClientLogout, storeClientDetails } from 'store/reducers/mainSlice';
import { useDispatch, useSelector } from 'react-redux';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { AiOutlinePoweroff } from 'react-icons/ai';
import './client.scss';
import NavBar from './NavBar';
import Sidebar from './SideBar';
import SidebarMobile from './SideBarMobile';
import Footer from './Footer';
// import Chatbox from './Chatbox';

// START: New Inner Component
// This component contains all the layout's content and can safely use the language context.
const LayoutContent = () => {
	const history = useNavigate();
	const [showSearch, setShowSearch] = useState(false);
	const displayTheme = useSelector((state) => state.main.displayTheme);
	const [clientlog, setClientLog] = useState(false);
	const dispatch = useDispatch();
	const clientUser = useSelector((state) => state.main.client);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [mobileNav, setMobileNav] = useState(false);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const [isBlur, setIsBlur] = useState(false);
	const [searchActive, setSearchActive] = useState(false);
	const [burgerActive, setBurgerActive] = useState(false);
	const [profileActive, setProfileActive] = useState(false);
	const path = window.location.pathname;
	const pathSegments = path.split('/');
	const lastSegment = pathSegments[pathSegments.length - 1];
	const [chatBoxOpen, setChatBoxOpen] = useState(false);
	const [salesManager, setSalesManager] = useState([]);
	const [activeChatMenu, setActiveChatMenu] = useState('menu');
	const INACTIVITY_TIME = 30 * 60 * 1000; // 30 minutes in milliseconds
	const { t, locale } = useLanguage();

	useHotkeys('/', () => handleSearchToggle());

	const LogOutHandler = () => {
		dispatch(setClientLogout(false));
		// api.clientlogout().then();
		window.localStorage?.removeItem('client');
		window.sessionStorage?.removeItem('client');
		dispatch(storeClientDetails(null));
		history('/client');
	};

	useEffect(() => {
		if (locale === 'ae') {
			document.documentElement.dir = 'rtl';
		} else {
			document.documentElement.dir = 'ltr';
		}
		return () => {
			document.documentElement.dir = 'ltr';
		};
	}, [locale]);

	useEffect(() => {
		let logoutTimer;
		const resetTimer = () => {
			clearTimeout(logoutTimer);
			logoutTimer = setTimeout(LogOutHandler, INACTIVITY_TIME);
		};
		window.addEventListener('mousemove', resetTimer);
		window.addEventListener('keydown', resetTimer);
		window.addEventListener('scroll', resetTimer);
		resetTimer();
		return () => {
			clearTimeout(logoutTimer);
			window.removeEventListener('mousemove', resetTimer);
			window.removeEventListener('keydown', resetTimer);
			window.removeEventListener('scroll', resetTimer);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (clientUser?.data) {
			// api.getClientInfo...
		}
	}, [clientUser, dispatch]);

	useEffect(() => {
		document.body.id = 'page-top';
		if (!displayTheme) {
			const storedTheme = localStorage.getItem('displayTheme') || 'lightMode';
			dispatch(setDisplayTheme(storedTheme));
		}
		if (!clientUser?.token) {
			history('/client');
		}
	}, [clientUser, displayTheme, dispatch, history]);

	const handleClientFromSide = () => setClientLog(true);
	const handleNavOpen = () => setMobileNav((prev) => !prev);

	useEffect(() => {
		document.body.className = displayTheme;
	}, [displayTheme]);

	const handleSearchToggle = () => setShowSearch(!showSearch);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const styles = {
		width: '100%',
		height: isMobile ? 'auto' : '100%'
	};

	return (
		<>
			<div id="parent-client-wrapper">
				<div id="wrapper">
					<NavBar onSearchToggle={handleSearchToggle} />
					<div id="new-wrapper" style={{ position: 'relative' }}>
						{!isMobile ? (
							<Sidebar clientLogout={handleClientFromSide} style={{ height: '93vh !important' }} />
						) : (
							<SidebarMobile
								clientLogout={handleClientFromSide}
								mobileNav={mobileNav}
								setMobileNav={setMobileNav}
								setIsBlur={setIsBlur}
								setBurgerActive={setBurgerActive}
							/>
						)}
						<div
							id="content-wrapper-2"
							className={`d-flex flex-column ${isBlur ? 'blur' : ''}`}
							style={{
								overflowY: 'auto',
    							height: 'calc(100vh - 60px)',
								scrollbarWidth: 'thin',
								scrollbarColor: '#0966ff transparent'
							}}
						>
							<div
								id="content"
								style={{
									position: 'relative',
									height: lastSegment === 'company-verified' || lastSegment === 'check-warranty' ? '100%' : isMobile ? 'auto' : '100%'
								}}
							>
								<div
									className={`container-fluid d-flex justify-content-center ${isMobile ? 'padding-mobile-client' : ''}`}
									style={{
										height: lastSegment === 'company-verified' || lastSegment === 'check-warranty' ? '100%' : isMobile ? 'auto' : '100%'
									}}
								>
									<div style={styles}>
										<Outlet />
									</div>
								</div>
							</div>
							{/* <Chatbox ... /> */}
						</div>
					</div>
					{isMobile && (
						<div id="footer-mobile" style={{ zIndex: 12 }}>
							<Footer
								onnavopen={handleNavOpen}
								mobileNav={mobileNav}
								clientLogout={handleClientFromSide}
								isBlur={isBlur}
								setIsBlur={setIsBlur}
								setBurgerActive={setBurgerActive}
								setProfileActive={setProfileActive}
								burgerActive={burgerActive}
								profileActive={profileActive}
								setMobileNav={setMobileNav}
								setSearchActive={setSearchActive}
								searchActive={searchActive}
							/>
						</div>
					)}
					{/* <Chatbox ... /> */}
				</div>
			</div>
			<ScrollButton />
			{clientlog && (
				<ActionConfirmationModal
					show={clientlog}
					title={t('logout-popup.ready-to-leave')}
					customIcon={<AiOutlinePoweroff size={35} />}
					customConfirmText={t('logout-popup.logout')}
					customCancelText={t('logout-popup.cancel')}
					handleClose={() => setClientLog(false)}
					handleConfirm={LogOutHandler}
					confirmDanger
				/>
			)}
			<GlobalSearch show={showSearch} onForceClose={() => setShowSearch(false)} />
			<Toaster toastOptions={{ className: 'toaster-styles-2' }} />
		</>
	);
};
// END: New Inner Component

const ClientLayout = () => {
	const getInitialLocale = () => {
		const localeCookie = Cookies.get('locale');
		if (['en', 'nl', 'es', 'it', 'ae'].includes(localeCookie)) {
			return localeCookie;
		}
		return 'en';
	};

	const initialLocale = getInitialLocale();

	return (
		<LanguageProvider initialLocale={initialLocale}>
			<LayoutContent />
		</LanguageProvider>
	);
};

export default ClientLayout;

